import React from 'react';
import ReactDOM from 'react-dom';
import { CssBaseline, ThemeProvider, LoadingProvider } from '@smile-next/uikit';
import { App } from '@/App';
import { readyRepositories } from '@/infra/repository';

// プラグインのインストール
import '@/plugins';

readyRepositories().then(() => {
    ReactDOM.render(
        <React.StrictMode>
            <CssBaseline />
            <ThemeProvider>
                <LoadingProvider>
                    <App />
                </LoadingProvider>
            </ThemeProvider>
        </React.StrictMode>,
        document.getElementById('root'),
    );
});
